import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';
import store from '../store/index';

// Init router
const router = new VueRouter({
    mode: 'history',
    routes: routes,
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    }
});

router.beforeEach((to, from, next) => {
    // console.log('BEFORE EACH');

    // GET PORTFOLIO FOR MOBILE MENU
    store.dispatch("getPortfolio");

    // SEO
    document.title = to.meta.title;

    // Turn the meta tag definitions into actual elements in the head.
    // to.meta.metaTags.map(tagDef => {
    //         const tag = document.createElement('meta')

    //         Object.keys(tagDef).forEach(key => {
    //             tag.setAttribute(key, tagDef[key])
    //         })

    //         // console.log('tag:', tag)

    //         // We use this to track which meta tags we create so we don't interfere with other ones.
    //         tag.setAttribute('data-vue-router-controlled', '')

    //         console.log('tag:', tag)

    //         return tag
    //     })
    //     // Add the meta tags to the document head.
    //     .forEach(tag => document.head.appendChild(tag));

    // PAGE LOADER
    // reset page ready state
    store.dispatch('togglePageReady', false);

    // reset counter
    let tempDuration = router.app.$root.loaderCountDuration;
    router.app.$root.loaderCountDuration = 1;
    router.app.$root.loaderPercentageOld = 0;
    router.app.$root.loaderPercentage = 15;
    router.app.$root.loaderCountDuration = tempDuration;
    tempDuration = null;

    // set gallery name
    if (to.params.category) {
        store.state.pageName = to.params.category.replace("-", " ");
    } else {
        if (to.name === "login") {
            store.state.pageName = "client-area";
        } else {
            store.state.pageName = to.name;
        }

    }

    // show loader
    const showLoader = () => {
        if (router.app.$root.loaderInitialized) {
            let circleBigColor = to.meta.background ? to.meta.background : "#fff";
            let circleSmall = to.meta.background === '#000' ? '#fff' : "#000";

            router.app.$root.$refs['circle-small'].children[0].style.backgroundColor = circleSmall;
            router.app.$root.$refs['text'].style.color = circleBigColor;
            router.app.$root.$refs['circle-big'].children[0].style.backgroundColor = circleBigColor;
            router.app.$root.$refs['circle-half-top'].style.backgroundColor = circleBigColor;
            router.app.$root.$refs['circle-half-bottom'].style.backgroundColor = circleBigColor;
            router.app.$root.$refs['circle-half-1'].style.backgroundColor = circleBigColor;
            router.app.$root.$refs['circle-half-2'].style.backgroundColor = circleBigColor;


            if (!router.app.$root.loaderIsActive) {
                router.app.$root.showLoader()
                    .then(() => {
                        if (router.app.$root.smoothScroller) {
                            router.app.$root.smoothScroller.destroy()
                            router.app.$root.scrollerInitiated = false
                            router.app.$root.smoothScroller = null
                        }
                        
                        next();
                    });
            } else {
                next();
            }
        } else {
            next();
        }
    };

    if (!router.app.$root.isDevice && router.app.$root.smoothScroller && router.app.$root.smoothScroller.el.firstChild.style.transform !== "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)") {
        router.app.$root.scrollToTop(() => {
            showLoader();
        })
    } else {
        showLoader();
    }
})

router.afterEach(() => {
    // console.log('AFTER EACH')
    if(window.Laravel.app_env == 'production'){
        gtag('config', 'G-XMTCX1Z3PN');
    }
    // MOBILE MENU
    if (router.app.$root.$refs['mobile-menu'] && router.app.$root.mobileMenuOpen) {
        router.app.$root.closeSiteDrawer('mobile-menu');
    }

    // PAGE LOADER
    const watchLoaderInitialized = () => {
        if (router.app.$root.loaderInitialized) {
            window.cancelAnimationFrame(watchLoaderInitialized)
            if (router.app.$root.loaderIsActive) {
                router.app.$root.hideLoader();

                if (router.app.$root.$refs['cursor']) {
                    router.app.$root.$refs['cursor'].addInteractors();
                }
            }
        } else {
            window.requestAnimationFrame(watchLoaderInitialized);
        }
    }

    window.requestAnimationFrame(watchLoaderInitialized);
})

export default router